export var CopyToClipboardStatus;
(function (CopyToClipboardStatus) {
    CopyToClipboardStatus["Pending"] = "pending";
    CopyToClipboardStatus["Success"] = "success";
    CopyToClipboardStatus["Error"] = "error";
})(CopyToClipboardStatus || (CopyToClipboardStatus = {}));
